import React from "react";
import "./GoodbyePage.css";

interface GoodbyePageProps {
  name?: string;
  message: string;
  subtext?: string;
  onLogout: () => void;
  // Defaults preserve the original farewell framing (waving hand + "Thank You!") for the two
  // call sites that pre-date these props (contractor account-deleted, tenant lease-ended). Override
  // both together for states that aren't actually a farewell -- e.g. "no active application yet" is
  // informational, not a goodbye, so a static icon + neutral title reads correctly there.
  icon?: string;
  title?: string;
  animateIcon?: boolean;
}

// Shared by the Tenant (lease ended / moved out / no active application) and Contractor (account
// deleted) goodbye/empty-state screens -- same layout, only the copy (and, for non-farewell states,
// the icon/title) differs per caller.
const GoodbyePage: React.FC<GoodbyePageProps> = ({
  name,
  message,
  subtext,
  onLogout,
  icon = "👋",
  title = "Thank You!",
  animateIcon = true,
}) => {
  return (
    <div className="goodbye-container">
      <div className="goodbye-card">
        <div className="goodbye-icon-wrapper">
          <div className={`goodbye-icon${animateIcon ? "" : " goodbye-icon--static"}`}>{icon}</div>
        </div>
        <h1 className="goodbye-title">{title}</h1>
        <p className="goodbye-message">
          {name ? `Dear ${name}, ` : ""}
          {message}
        </p>
        {subtext && <p className="goodbye-subtext">{subtext}</p>}
        <p className="goodbye-contact">
          If you believe this is a mistake, please contact your property manager for assistance.
        </p>

        <button className="goodbye-logout-btn" onClick={onLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default GoodbyePage;
